import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=5a6ca43d&scoped=true&"
import script from "./ContactForm.vue?vue&type=script&lang=ts&"
export * from "./ContactForm.vue?vue&type=script&lang=ts&"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=5a6ca43d&lang=scss&scoped=true&"
import style1 from "./ContactForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6ca43d",
  null
  
)

export default component.exports